import { render, staticRenderFns } from "./FeedbackStepper.vue?vue&type=template&id=0c8e7f63&scoped=true&"
import script from "./FeedbackStepper.vue?vue&type=script&lang=js&"
export * from "./FeedbackStepper.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackStepper.vue?vue&type=style&index=0&id=0c8e7f63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e7f63",
  null
  
)

export default component.exports